import ReduxModelGenerator from './model-generator';
import { combineModels } from './utils/redux';
import { query, fragment } from './utils/queries';
import { mapState, mapDispatch, withModel, mapEntityState, mapEntityListState, mapEntityDispatch, withEntityList, withEntity, withQuery, mapValueListState, mapValueListDispatch, withValueLists, generateActionCreators, mergeProps } from './connectors';
import { fixCasing } from './mappings';
import { touchEtag } from './actions/entities';
import useModelActions from './hooks/use-model-actions';
import useModelState from './hooks/use-model-state';
import useEntity from './hooks/use-entity';
import useEntityList from './hooks/use-entity-list';
import useEntityQuery from './hooks/use-entity-query';
import useEntityListQuery from './hooks/use-entity-list-query'; // testing

import { createEntityMock } from './test-utils/mocks';
import { createMockStore } from './test-utils/store';
import { createMockEntity } from './test-utils/entity';
import { createMockStoreWrapper } from './test-utils/wrapper';
export default ReduxModelGenerator;
export { combineModels, generateActionCreators, mergeProps, mapState, mapDispatch, withModel, mapEntityState, mapEntityListState, mapEntityDispatch, withEntityList, withEntity, withQuery, mapValueListState, mapValueListDispatch, withValueLists, fixCasing, query, fragment, touchEtag, createEntityMock, useModelActions, useModelState, useEntity, useEntityList, useEntityQuery, useEntityListQuery, createMockStore, createMockEntity, createMockStoreWrapper, ReduxModelGenerator };